import React, { Component } from "react"
import { Card, Col, Row } from "reactstrap"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { FaFilePdf } from "react-icons/fa"
import API from "../../apis"
import demo from "../../assets/videos/demoEtud.mp4"
import FileDownload from "js-file-download"

class NewsGrid extends Component {
  constructor(props) {
    super(props)

    // Récupération de l'étudiant connecté
    const userAuthEtudiant = JSON.parse(
      localStorage.getItem("userAuthEtudiant")
    )

    const user = userAuthEtudiant?.user || {}

    this.etudiant_id = user.id_etudiant
    this.annee_id = user.annee_id

    this.state = {
      nouveautes: [
        {
          id: 1,
          title: "L'emploi du temps",
          link: "/EmploiEnseignant",
          date: "04/03/2022",
          image:
            "https://www.wikihow.com/images_en/thumb/2/26/Do-Homework-Step-6-Version-3.jpg/v4-460px-Do-Homework-Step-6-Version-3.jpg.webp",
          description: "Emploi du temps de l'enseignant",
        },
        {
          id: 2,
          title: "L'emploi des examens",
          link: "/CalendrierExam",
          date: "05/03/2022",
          image:
            "https://www.wikihow.com/images_en/thumb/2/26/Do-Homework-Step-6-Version-3.jpg/v4-460px-Do-Homework-Step-6-Version-3.jpg.webp",
          description: "Emploi des examens de l'enseignant",
        },
      ],

      avis: [],
    }
  }

  componentDidMount() {
    this.loadAvis()
  }

  loadAvis = () => {
    const { etudiant_id, annee_id } = this

    if (!etudiant_id || !annee_id) {
      console.error("Informations étudiant manquantes", {
        etudiant_id,
        annee_id,
      })
      return
    }

    API.post("avis_etudiants/mes_avis", {
      annee_id: annee_id,
      etudiant_id: etudiant_id,
    })
      .then(res => {
        const avis =
          res.data?.Avis?.map(item => ({
            id: item.id,
            title: item.titre,
            description: item.contenu,

            // Adapter ce champ au nom retourné par ton API
            download: item.url_pdf || item.pdf || item.fichier_url,

            name: "Télécharger",
            color: "#014f9c",
            icon: <FaFilePdf />,
          })) || []

        this.setState({ avis })
      })
      .catch(err => {
        console.error("Erreur lors du chargement des avis :", err)
        this.setState({ avis: [] })
      })
  }
  // ✅ Ouvre/ferme la modal détail
  // download = (tile = null) => {
  //   try {
  //     console.log(tile)
  //     // On attend la réponse avec await
  //     const res =  API.post(
  //       "avis_etudiants/download",
  //       {
  //         id: tile.id,
  //       },
  //       { responseType: "blob" } // Important pour les fichiers binaires
  //     )
  //     // On télécharge le fichier avec le nom souhaité
  //     FileDownload(res.data, `${tile.title}.pdf`)
  //   } catch (error) {
  //     console.error("Erreur lors du téléchargement :", error)
  //   }
  // }

  download = async (tile = null) => {
    try {
      if (!tile || !tile.id) {
        console.error("Aucun fichier sélectionné")
        return
      }
      const res = await API.post(
        "avis_etudiants/download",
        {
          id: tile.id,
        },
        {
          responseType: "blob",
        }
      )
      // Vérifier que le fichier n'est pas vide
      if (!res.data || res.data.size === 0) {
        console.error("Le fichier retourné par l'API est vide")
        return
      }
      // Récupérer le nom du fichier
      const fileName = `${tile.title}.pdf`
      FileDownload(res.data, fileName)
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error)
      if (error.response) {
        console.error("Status :", error.response.status)
        console.error("Data :", error.response.data)
      }
    }
  }

  render() {
    const { avis } = this.state
    const { t } = this.props

    return (
      <React.Fragment>
        <Col md={12} lg={12} xl={12}>
          <Card>
            <div className="container-fluid">
              {/* Titre */}
              <h2
                style={{
                  color: "#556ee6",
                  textAlign: "center",
                }}
                className="mb-4"
              >
                {t("Bienvenue dans l'espace Etudiant")}
              </h2>

              {/* Titre avis */}
              <h4
                style={{
                  textAlign: "center",
                  marginBottom: "25px",
                }}
              >
                {t("Les avis disponibles")}
              </h4>

              {/* Liste des avis */}
              <Row>
                {avis.length > 0 ? (
                  avis.map((tile, index) => (
                    <Col
                      md="3"
                      sm="6"
                      xs="12"
                      key={tile.id || index}
                      className="mb-4"
                    >
                      <Card
                        style={{
                          backgroundColor: tile.color,
                          borderRadius: "10px",
                          cursor: "pointer",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          transition: "transform 0.3s, box-shadow 0.3s",
                          color: "#fff",
                          height: "100%",
                          minHeight: "280px",
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden",
                        }}
                        onMouseEnter={e => {
                          e.currentTarget.style.transform = "scale(1.03)"
                          e.currentTarget.style.boxShadow =
                            "0 10px 20px rgba(0,0,0,0.3)"
                        }}
                        onMouseLeave={e => {
                          e.currentTarget.style.transform = "scale(1)"
                          e.currentTarget.style.boxShadow =
                            "0 4px 8px rgba(0,0,0,0.2)"
                        }}
                      >
                        {/* Contenu */}
                        <div
                          style={{
                            padding: "20px",
                            textAlign: "center",
                            flex: 1,
                          }}
                        >
                          {/* Icone */}
                          <div
                            style={{
                              backgroundColor: "#fff",
                              borderRadius: "50%",
                              width: "70px",
                              height: "70px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              margin: "0 auto 15px",
                            }}
                          >
                            {React.cloneElement(tile.icon, {
                              size: 35,
                              color: tile.color,
                            })}
                          </div>

                          {/* Titre */}
                          <div
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              marginBottom: "10px",
                            }}
                          >
                            {tile.title}
                          </div>

                          <hr
                            style={{
                              borderColor: "rgba(255,255,255,0.5)",
                            }}
                          />

                          {/* Description */}
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "10px",
                            }}
                          >
                            {tile.description}
                          </div>
                        </div>

                        {/* Action */}
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "10px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            borderTop: `2px solid ${tile.color}`,
                          }}
                        >
                          {tile.download ? (
                            <a
                              // href={tile.download}
                              onClick={() => this.download(tile)}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "6px 15px",
                                border: `1px solid ${tile.color}`,
                                borderRadius: "5px",
                                color: tile.color,
                                fontWeight: "bold",
                                textDecoration: "none",
                                gap: "10px",
                                transition: "0.3s",
                              }}
                              onMouseEnter={e => {
                                e.currentTarget.style.backgroundColor =
                                  tile.color
                                e.currentTarget.style.color = "#fff"
                              }}
                              onMouseLeave={e => {
                                e.currentTarget.style.backgroundColor = "#fff"
                                e.currentTarget.style.color = tile.color
                              }}
                            >
                              <FaFilePdf />
                              {tile.name}
                            </a>
                          ) : (
                            <span
                              style={{
                                color: "#999",
                                fontSize: "13px",
                              }}
                            >
                              PDF non disponible
                            </span>
                          )}
                        </div>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <Col md="12">
                    <div
                      className="text-center"
                      style={{
                        padding: "30px",
                        color: "#777",
                      }}
                    >
                      {t("Aucun avis disponible")}
                    </div>
                  </Col>
                )}
              </Row>

              {/* Guide */}
              <h4
                className="text-center"
                style={{
                  marginTop: "30px",
                  marginBottom: "20px",
                }}
              >
                {t("Vous êtes invités à consulter ce guide d'utilisation.")}
              </h4>

              {/* Vidéo */}
              <Row>
                <Col md="12">
                  <video
                    controls
                    width="100%"
                    style={{
                      borderRadius: "10px",
                    }}
                  >
                    <source src={demo} type="video/mp4" />
                    Votre navigateur ne supporte pas la vidéo.
                  </video>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
      </React.Fragment>
    )
  }
}

NewsGrid.propTypes = {
  t: PropTypes.func,
}

export default withRouter(withTranslation()(NewsGrid))
